module.exports = __webpack_public_path__ + "static/media/Pick_and_place_task_planning_and_motion_control.eca61b71.gif";